import { usePageHeader } from '@/context/PageHeadingContext';
import { ElementType } from 'react';
import { Link } from 'react-router-dom';
import BorderHeading from 'ui/components/BorderHeading';

type PageHeadingProps = {
  component?: ElementType;
};

const PageHeading = ({ component }: PageHeadingProps) => {
  const { pageHeaderOptions } = usePageHeader();

  if (pageHeaderOptions.hide) {
    return null;
  }

  return (
    <BorderHeading
      data-clarity-unmask='True'
      title={pageHeaderOptions.title}
      overline={
        pageHeaderOptions.backText && pageHeaderOptions.backHref
          ? pageHeaderOptions.backText
          : undefined
      }
      subtitle={pageHeaderOptions.subtitle}
      component={component}
      backHref={pageHeaderOptions.backHref}
      linkComponent={Link}
      maskTitle={pageHeaderOptions.maskTitle}
    />
  );
};

export default PageHeading;
